import React, { useEffect } from "react";
import { useState, useRef } from "react";
import Navbar from "../../Navbar";
import Footer from "../../Footer";
import { config } from "../../api/api";
import { useLocation } from "react-router-dom";
const MotorRenewQuoteSummary = () => {
  // const [isClicked, setIsClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeButton, setActiveButton] = useState(-1);
  const [isClickedWhatsapp, setIsClickedWhatsapp] = useState(false);
  const [errors, setErrors] = useState({});
  const [details, setDetails] = useState(null);

  const [sameAsMobile, setSameAsMobile] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const base_url = config.baseURL;
  const vendor_key =
    "yeflesxnwar1xh31o6pg4ww9fr03ohn74u4h6oy0xx4qpzot0aqbhwlhbiv55k0qf1bls12v7zrlhriuu77wcytijxdzvfrfnxlhq68y30eiy59ok01iyn1xzyangrew9w19cchvd62js5164j4bmfcauj3vc7qkpqkjdl7hdpzxc2xzoq35ehuq3gzybhh1rc3v6tr5slr2ivv958ixq35k5meh3626v3g9sckyp267o8vup7kd72ntp9udknjz";

  const insuredMobileNoRef = useRef(null);
  const insuredEmailIdRef = useRef(null);
  const insuredWhatsappRef = useRef(null);

    const [allow,setAllow]=  useState(false);
  
       useEffect(()=>{
               const getBasicInfo=sessionStorage.getItem("motorBasicDetails");
               if(!getBasicInfo){
                  window.location.href="/motor-insurance-page"
               }
               else{
                setAllow(true);
               }
            },[])
  

  const handleClick = (buttonId) => {
    setActiveButton(buttonId);

    const prodID = formData?.prodId || "";
    const match = prodID.match(/^(\d+)/);
    if (match) {
      setFormData({ ...formData, prodId: match[1] });
    }
    // const prodID = formData.prodId;
    // const match = prodID.match(/^(\d+)/); // for extract 0502
    // if (match) {
    //   setFormData({ ...formData, prodId: match[1] });
    // }

    setFormData({
      ...formData,
      packageId: details.packageDetails[buttonId].$.id,
      planSelection: details.packageDetails[buttonId].planSelection,
      premiumAmount: details.packageDetails[buttonId].premiumAmt,
      obtainedCover: details.packageDetails[buttonId].obtainedCvr,
    });
  };

  const handleWhatsapp = (e) => {
    setIsClickedWhatsapp(e.target.checked);
    if (isClickedWhatsapp === true) {
      setFormData((prev) => ({
        ...prev,

        insuredWhatsapp: "",
      }));
      setSameAsMobile(false);
    }
  };

  const [formData, setFormData] = useState({
    prodId: "",
    packageId: "",
    planSelection: "",
    premiumAmount: "",
    obtainedCover: "",
    quoteNo: "",
    srcBusId: "SJET",
    insuredMobileNo: "",
    insuredWhatsapp: "",
    insuredEmailId: "",
  });

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const handleChange = (e) => {
    const { name, value } = e.target;
    const trimValue = value.trimStart();

    const numberRegex = /^[0-9]*$/;

    if (name === "insuredMobileNo") {
      if (numberRegex.test(trimValue)) {
        setFormData({ ...formData, [name]: trimValue });
      }
      return;
    }
    if (name === "insuredWhatsapp") {
      if (numberRegex.test(trimValue)) {
        setFormData({ ...formData, [name]: trimValue });
      }
      return;
    }
    if (name === "insuredEmailId") {
      setFormData({ ...formData, [name]: trimValue });
      return;
    }
    if (name === "checkBox") {
      setIsChecked(e.target.checked);
      return;
    } else {
      setFormData({ ...formData, [name]: trimValue });
    }
  };

  const validationDetails = () => {
    let newErrors = {};

    if (!formData.insuredMobileNo) {
      newErrors.insuredMobileNo = "MobileNo is Required";
    }
    if (!formData.insuredWhatsapp) {
      newErrors.insuredWhatsapp = "Whatsapp is Required";
    }
    if (emailChecked === true) {
      const email = formData.insuredEmailId.trim();
      if (!email) {
        newErrors.insuredEmailId = "Email Id is Required";
      } else if (!emailRegex.test(email)) {
        newErrors.insuredEmailId = "Enter valid Email Id";
      }
    }

    if (!isChecked) {
      newErrors.checkBox = "accept is required";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      const firstErrorField = Object.keys(newErrors)[0];
      switch (firstErrorField) {
        case "insuredMobileNo":
          insuredMobileNoRef.current.focus();
          break;
        case "insuredWhatsapp":
          insuredWhatsappRef.current.focus();
          break;
        case "insuredEmailId":
          insuredEmailIdRef.current.focus();
          break;
        default:
          break;
      }
      return false;
    }

    return Object.keys(newErrors).length === 0; // If no errors, return true
  };

  const handleValidation = (e) => {
    const { name } = e.target;
    if (formData[name]?.trim()) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  //data from prev page

  const [mobileNoChecked, setMobileNoChecked] = useState(false);
  const [emailChecked, setEmailChecked] = useState(false);

  const { state } = useLocation();
  const { quoteDetails } = state;

  useEffect(() => {
    setDetails(quoteDetails);
    console.log(details, "initcheck");
    if (quoteDetails?.prodId) {
      const match = quoteDetails.prodId.match(/^(\d+)/);
      setFormData((prev) => ({
        ...prev,
        prodId: match ? match[1] : quoteDetails.prodId,
        insuredMobileNo: quoteDetails.insuredDetails?.insuredMobileNo || "",
      }));
    }
    // const match = quoteDetails.prodId.match(/^(\d+)/);
    // setFormData((prev) => ({
    //   ...prev,
    //   prodId: match ? match[1] : quoteDetails.prodId,// store "0502"
    //   insuredMobileNo: quoteDetails.insuredDetails.insuredMobileNo,
    // }));
    console.log(quoteDetails, "check");

    setMobileNoChecked(true);
  }, [quoteDetails]);

  //4709908 civ
  //251 A

  const handleMobileNo = (e) => {
    const checked = e.target.checked;
    setMobileNoChecked(checked);

    if (checked) {
      setFormData((prev) => ({
        ...prev,
        insuredMobileNo: quoteDetails.insuredDetails.insuredMobileNo,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        insuredMobileNo: "",
      }));
    }
  };

  const handleEmail = (e) => {
    setEmailChecked(e.target.checked);
  };

  // const prodID = formData.prodId;
  //       const match = prodID.match(/^(\d+)/);   // for extract 0502
  //       if(match){
  //        setFormData({...formData,prodId:match[1]})

  //       }

  const package_Details = async () => {
    try {
      const package_payload = {
        prodId: formData.prodId,
        packageId: formData.packageId,
        planSelection: formData.planSelection,
        premiumAmount: formData.premiumAmount,
        obtainedCover: formData.obtainedCover,
        quoteNo: details.transactionDetails.quoteNo || details.renewalQuoteNo,
        srcBusId: "SJET",
      };
      const response = await fetch(base_url + "/confirm_package_plan", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer" + vendor_key,
        },
        body: JSON.stringify(package_payload),
      });

      if (!response.ok) throw new Error("API request failed");
      const data = await response.json();

      return data;
    } catch (error) {
      console.log("unable to fetch data", error);
    }
  };


  const Communication_Details = async (Communication_payload) => {
    try {
      const response = await fetch(base_url + "/update_communication_prefer", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + vendor_key,
        },
        body: JSON.stringify(Communication_payload),
      });
      if (!response.ok) throw new Error("API request Failed");

      const data = await response.json();

      return data;
    } catch (error) {
      console.log("unable to fetch communication data", error);
    }
  };

  const payment_Details = async (payment_payload) => {
    try {
      const response = await fetch(base_url + "/motor_ins_payments", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + vendor_key,
        },
        body: JSON.stringify(payment_payload),
      });
      if (!response.ok) throw new Error("API request failed");
      const data = await response.json();

      // console.log(data,"paydata");

      return data;
    } catch (error) {
      console.log(error);
    }
  };

  const handlePay = async (e) => {
    e.preventDefault();
    try {
      if (!validationDetails()) return;

      setLoading(true);

      const packageData = await package_Details();
      if (!packageData || packageData.result.status !== "Y") {
        console.error("Package data failed");
        return;
      }

   

      const Communication_payload = {
        licenseNo: details.insuredDetails.insuredLicNo, // civil id
        quoteNo: packageData.result.quoteNo,
        agentCode: "Agent1",
        emailId: formData.insuredEmailId,
        mobileCountry: "+91",
        mobileNo: formData.insuredMobileNo,
        whatsappNo: formData.insuredWhatsapp,
      };

      const communicationData = await Communication_Details(
        Communication_payload
      );
      if (
        communicationData.message !== "success" ||
        communicationData.result.message !== "S"
      ) {
        console.error("Communication Data failed");
        return;
      }

      const payment_payload = {
        quoteNo: packageData.result.quoteNo,
        amount: formData.premiumAmount,
      };

      const paymentData = await payment_Details(payment_payload);
      if (paymentData.message !== "success") {
        console.error("Payment details failed");
        return;
      }

      window.location.href = paymentData.result?.data;
    } catch (error) {
      console.error("Error in handlePay:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
   {  allow &&
   <>
    <div className="header_section1">
        <Navbar />

        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">Quote Summary</h3>
          </div>
        </div>
      </div>

      <div className="features_section">
        <div className="container  mt-3">
          {details?.effectiveDt && (
            <div className="row">
              <div className=" col-md-6 mt-3">
                <div className="border shadow rounded p-3">
                  <h3>Vehicle</h3>
                  <div className=" border d-flex flex-wrap p-3 align-items-center justify-content-between mb-2">
                    <div className="p-0">
                      <h3 className=" p-0">
                        {details?.vehicleDetails.make}{" "}
                        {details?.vehicleDetails.model}
                      </h3>

                      <p className="m-0">{details.vehicleDetails.manuYear}</p>
                    </div>
                    <div className="">
                      <button className="btn btn-primary">
                        {details.vehicleDetails.vehRegNo}{" "}
                        {details.vehicleDetails.vehRegLOC}
                      </button>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <h5 className="p-0">Chassis no.</h5>
                      <p>{details.vehicleDetails.chasisNo}</p>
                    </div>
                    <div className="col-md-6">
                      <h5 className="p-0">Body Type</h5>
                      <p>{details.vehicleDetails.vehBody}</p>
                    </div>
                    <div className="col-md-6 ">
                      <h5 className="p-0">Usage Type</h5>
                      <p>{details.vehicleDetails.usage}</p>
                    </div>
                  </div>
                </div>
                <div className="border shadow rounded p-3 mt-2">
                  <h3>Insured</h3>

                  <div className="row">
                    <div className="col-md-12 ">
                      <h5 className="p-0">Insured Name</h5>
                      <p>{details.insuredDetails.insureFullName}</p>
                    </div>
                    <div className="col-md-6 ">
                      <h5 className="p-0">Civil id</h5>
                      <p> {details.insuredDetails.insuredLicNo}</p>
                    </div>
                    <div className="col-md-6">
                      <h5 className="p-0">Age</h5>
                      <p>{details.insuredDetails.insuredAge}</p>
                    </div>
                  </div>
                </div>

                <div className="border shadow rounded p-3 mt-2">
                  <h3>Communication Preference</h3>
                  <div>
                    <h5>Your Communication Preference and Consent</h5>
                    <p>
                      Please select how you'd like to receive policy documents
                      and communications. By choosing your preferred mode, you
                      consent to receiving documents and related updates
                      electronically. You can update these preferences anytime.
                      Preferred Communication Mode (I consent for receiving
                      policy documents, related updates and communications
                      electronically)
                    </p>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mt-2">
                      <label className="mb-0 mt-1 ">
                        <input
                          type="checkbox"
                          checked={mobileNoChecked}
                          onChange={handleMobileNo}
                        />{" "}
                        Mobile Number
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="insuredMobileNo"
                        value={formData?.insuredMobileNo}
                        onChange={handleChange}
                        // disabled={mobileNoChecked === false}
                        disabled={!mobileNoChecked}
                        ref={insuredMobileNoRef}
                        onBlur={handleValidation}
                      />
                      {errors.insuredMobileNo && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.insuredMobileNo}
                        </span>
                      )}
                    </div>

                    <div className="col-md-6  mt-2">
                      <div className="p-0 d-flex justify-content-between">
                        <label className="mb-0 mt-1 ">
                          <input
                            type="checkbox"
                            checked={isClickedWhatsapp}
                            onClick={handleWhatsapp}
                          />{" "}
                          Whatsapp<span style={{ color: "red" }}>*</span>
                        </label>

                        {isClickedWhatsapp && (
                          <div className="p-0 d-flex justify-content-center align-items-center ">
                            <input
                              type="checkbox"
                              checked={sameAsMobile}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setSameAsMobile(checked);

                                if (checked) {
                                  setFormData({
                                    ...formData,
                                    insuredWhatsapp: formData.insuredMobileNo,
                                  });
                                } else {
                                  setFormData({
                                    ...formData,
                                    insuredWhatsapp: "",
                                  });
                                }
                              }}
                            />
                            <label
                              className="mb-0 ml-1"
                              style={{ fontSize: "8px" }}
                            >
                              Same as mobile no.
                            </label>
                          </div>
                        )}
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        name="insuredWhatsapp"
                        value={formData.insuredWhatsapp}
                        onChange={handleChange}
                        ref={insuredWhatsappRef}
                        onBlur={handleValidation}
                        disabled={!isClickedWhatsapp || sameAsMobile}
                      />
                      {errors.insuredWhatsapp && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.insuredWhatsapp}
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 mt-2">
                      <label className="mb-0 mt-1 ">
                        {" "}
                        <input
                          type="checkbox"
                          checked={emailChecked}
                          onClick={handleEmail}
                        />{" "}
                        Email
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="insuredEmailId"
                        ref={insuredEmailIdRef}
                        value={formData.insuredEmailId}
                        onChange={handleChange}
                        onBlur={handleValidation}
                        disabled={!emailChecked}
                      />
                      {errors.insuredEmailId && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.insuredEmailId}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 6 mt-3 ">
                <div className="border shadow rounded p-3">
                  <h3>Quote</h3>

                  <div className="row">
                    <div className="col-md-12 mt-1">
                      <h5 className="p-0">Quote no.</h5>
                      <p className="">
                        {details.transactionDetails.quoteNo ||
                          details.renewalQuoteNo}
                      </p>
                    </div>
                    <div className="col-md-6  mt-1">
                      <h5 className="p-0">Cover From Date</h5>
                      <p>{details.effectiveDt}</p>
                    </div>
                    <div className="col-md-6 mt-1">
                      <h5 className="p-0">Cover To Date</h5>
                      <p>{details.expirationDt}</p>
                    </div>
                    <div className="col-md-12 mt-1">
                      <h5 className="p-0">Product</h5>
                      <p>{details.prodId}</p>
                    </div>
                  </div>

                  <div className=" p-0">
                    <h5 className=" mt-1 ">Select Plan</h5>

                    <div className="row ">
                      {details?.packageDetails?.map((item, index) => (
                        <div key={index} className="col-md-12 mt-3">
                          <button
                            className="col-md-12"
                            style={{
                              border: "1px solid #3fd2f2",
                              backgroundColor:
                                activeButton === index ? "#3fd2f2" : "white",
                              color:
                                activeButton === index ? "white" : "#3fd2f2",
                            }}
                            onClick={() => handleClick(index)}
                          >
                            <div className="d-md-flex justify-content-md-between p-0">
                              <div>{item.planSelection}</div>
                              <div
                                style={{ fontWeight: "bolder", color: "black" }}
                              >
                                OMR {item.premiumAmt}
                              </div>
                            </div>
                          </button>
                        </div>
                      ))}

                      {activeButton >= 0 && (
                        <div
                          className="col-md-12 mt-3"
                          style={{ fontSize: "12px" }}
                        >
                          <input
                            type="checkbox"
                            name="checkBox"
                            onChange={handleChange}
                            onBlur={validationDetails}
                            checked={isChecked}
                          />{" "}
                          I accept the privacy policy
                          {errors.checkBox && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "10px",
                                marginLeft: "5px",
                              }}
                            >
                              ({errors.checkBox})
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {activeButton >= 0 && (
                  <div className=" border shadow rounded d-flex flex-wrap justify-content-between align-items-center mt-2 p-3">
                    <div className=" p-0">
                      <div className=" p-0 d-flex flex-wrap">
                        <span className="mb-0  p-0 ">NET PREMIUM</span>
                        <span>(including VAT & all other taxes)</span>
                      </div>

                      <h3>
                        OMR{" "}
                        {activeButton === 0
                          ? details.packageDetails[0].premiumAmt
                          : activeButton === 1
                          ? details.packageDetails[1].premiumAmt
                          : activeButton === 2
                          ? details.packageDetails[2].premiumAmt
                          : details.packageDetails[3].premiumAmt}
                      </h3>
                    </div>
                    <div className="">
                      <button className=" btn btn-primary" onClick={handlePay}>
                        PAY PREMIUM
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      <Footer />
      </>
      }
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
    </>
  );
};

export default MotorRenewQuoteSummary;
